import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6acb6711"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mx-0 px-0 pb-4 gx-3 mb-4" }
const _hoisted_2 = { class: "row mx-0 px-0 col-lg-6 d-flex align-items-center" }
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = { class: "fs-8" }
const _hoisted_6 = {
  key: 0,
  class: "fs-8"
}
const _hoisted_7 = {
  key: 1,
  class: "fs-8"
}
const _hoisted_8 = {
  key: 2,
  class: "fs-8"
}
const _hoisted_9 = { class: "fs-8" }
const _hoisted_10 = {
  key: 3,
  class: "fs-8"
}
const _hoisted_11 = {
  key: 4,
  class: "fs-8"
}
const _hoisted_12 = {
  key: 5,
  class: "fs-8"
}
const _hoisted_13 = {
  key: 6,
  class: "fs-8"
}
const _hoisted_14 = { class: "wrapper-img mt-3" }
const _hoisted_15 = {
  key: 0,
  class: "row align-items-center"
}
const _hoisted_16 = { class: "col-lg-8" }
const _hoisted_17 = { class: "community-banner" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_20 = { class: "me-5" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "mb-3 d-none" }

import { PropType, ref, watch, onMounted } from 'vue'
import InputErrorMessage from '../input-error-message/InputErrorMessage.vue'
import { translate } from '@/languages/i18n'
import { addCommunityHeaderParams, addCommunitySiteHeaderParams, addUserIconParams } from '@/use/usePath'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: '',
  },
  initImage: String,
  type: String,
  field: Object,
  setModelImage: Function as PropType<any>,
  noticeImage: { type: String, default: '' },
  params: Array,
  msgSize: {
    type: String,
    default: null,
  },
  msgNote: {
    type: String,
    default: null,
  },
},
  emits: ['setImage'],
  setup(__props, { emit }) {

const props = __props

const inputRef = ref()
const file = ref('')
const imgPreview = ref('')


onMounted(() => {
  file.value = ''
})
const getNameFile = (e) => {
  file.value = e.target.value.replace('C:\\fakepath\\', ' ')
  imgPreview.value = URL.createObjectURL(e.target.files[0])
  emit('setImage', file.value, imgPreview.value, e.target.files[0])
  props.setModelImage(e.target.files[0])
}

const handleFile = (event) => {
  event.target.value = ''
}

const handleDelImg = () => {
  file.value = ''
  imgPreview.value = ''
  emit('setImage', '')
  props.setModelImage('')
}

const handleClick = () => {
  if (inputRef.value) {
    inputRef.value.click()
  }
}



watch(
  () => props.initImage,
  () => {
    if (props.initImage) {
      if (typeof props.initImage === 'string') {
        file.value = props.initImage
        imgPreview.value = props.initImage
      } else {
        file.value = props.initImage?.name
        imgPreview.value = URL.createObjectURL(props.initImage)
      }
      emit('setImage', props.initImage, props.initImage, props.initImage)
      props.setModelImage('')
    }
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(['w-max-content col-lg-3 col-form-label ', __props.type != 'community-banner' ? 'fw-bold' : 'ps-6'])
    }, _toDisplayString(__props.title), 3),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(['col-lg-8 col-input', __props.field.$error ? 'is-invalid' : ''])
      }, [
        _createElementVNode("input", {
          type: "",
          class: "form-control fs-7 cursor-pointer",
          id: __props.title,
          placeholder: "ファイル選択",
          accept: "image/png, image/jpeg, image/jpg",
          onClick: handleClick,
          value: file.value,
          readonly: ""
        }, null, 8, _hoisted_3)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "button-select shadow button-router-link",
          onClick: handleClick
        }, _toDisplayString(_unref(translate)('selectFile')), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)('CO40text2')), 1),
        (__props.noticeImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(translate)('CO40text31')), 1))
          : _createCommentVNode("", true),
        (__props.msgSize)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.msgSize), 1))
          : (!__props.noticeImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(translate)('CO40text3')), 1))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('CO40text4')), 1),
        (__props.noticeImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.noticeImage), 1))
          : _createCommentVNode("", true),
        (__props.noticeImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('CO40text51')), 1))
          : _createCommentVNode("", true),
        (__props.msgNote)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(__props.msgNote), 1))
          : (!__props.noticeImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(translate)('CO40text5')), 1))
            : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_14, [
        (__props.type === 'community-banner')
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    src: _unref(addCommunitySiteHeaderParams)(imgPreview.value),
                    alt: "img"
                  }, null, 8, _hoisted_18)
                ])
              ]),
              _createElementVNode("div", { class: "col-lg-4" }, [
                _createElementVNode("button", {
                  onClick: handleDelImg,
                  type: "button",
                  class: "cursor-pointer text-decoration-underline btn-del button-router-link"
                }, "削除")
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("img", {
                  src: __props.type === 'avatar' ? _unref(addUserIconParams)(imgPreview.value, 'community_admin') : _unref(addCommunityHeaderParams)(imgPreview.value),
                  alt: "img",
                  class: _normalizeClass([__props.type === 'avatar' ? 'rounded-circle' : ''])
                }, null, 10, _hoisted_21)
              ]),
              _createElementVNode("button", {
                onClick: handleDelImg,
                type: "button",
                class: "cursor-pointer text-decoration-underline btn-del button-router-link"
              }, "削除")
            ]))
      ], 512), [
        [_vShow, !!imgPreview.value]
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("input", {
          type: "file",
          placeholder: "ファイルを選択",
          ref: (_value, _refs) => {
            _refs['inputRef'] = _value
            inputRef.value = _value
          },
          onChange: getNameFile,
          onClick: handleFile,
          accept: "image/png, image/jpeg, image/jpg"
        }, null, 544)
      ]),
      _createVNode(InputErrorMessage, {
        title: __props.title,
        validator: __props.field.$errors[0]?.$validator,
        params: __props.params
      }, null, 8, ["title", "validator", "params"])
    ])
  ]))
}
}

})